import React from 'react';
import { Copy, Mail } from 'lucide-react';
import { toast } from 'sonner';
import { WhatsAppIcon } from '../WhatsAppIcon';

const sans = { fontFamily: 'Montserrat, sans-serif' };
const smallBtn = 'inline-flex items-center gap-1.5 px-3 py-2 text-[11px] tracking-wider uppercase border border-white/20 text-white/70 hover:text-white hover:border-white/50 transition-colors';

export const linkUrl = (id) => `${window.location.origin}/pay/${id}`;

const shareText = (link) =>
  `Hi ${link.client_name}, here is your secure payment link for your ${link.package_name} with Elina K. Photography (${link.amount.toLocaleString()} AED): ${linkUrl(link.id)}`;

export const PaymentLinkRow = ({ link }) => {
  const url = linkUrl(link.id);
  const paid = link.status === 'paid';

  const copy = async () => {
    await navigator.clipboard.writeText(url);
    toast.success('Link copied');
  };

  return (
    <div className="p-5 border border-white/10 bg-[#242424]" data-testid={`payment-link-${link.id}`}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-white text-lg" style={{ fontFamily: 'Cormorant Garamond, serif' }}>{link.client_name}</p>
          <p className="text-[#b8b8b8] text-sm">{link.package_name} · <span className="text-[#c9a87c]">{link.amount.toLocaleString()} AED</span></p>
          {link.note && <p className="text-[#888] text-xs mt-1">{link.note}</p>}
          <p className="text-[#666] text-[11px] mt-2 break-all" style={sans} data-testid={`payment-link-url-${link.id}`}>{url}</p>
        </div>
        <span
          className={`px-3 py-1 text-[10px] tracking-widest uppercase ${paid ? 'bg-emerald-500/15 text-emerald-300' : 'bg-white/5 text-[#b8b8b8]'}`}
          style={sans}
          data-testid={`payment-link-status-${link.id}`}
        >
          {paid ? 'Paid' : 'Unpaid'}
        </span>
      </div>

      {!paid && (
        <div className="flex flex-wrap gap-2 mt-4" style={sans}>
          <button onClick={copy} className={smallBtn} data-testid={`payment-link-copy-${link.id}`}><Copy className="w-3.5 h-3.5" /> Copy link</button>
          <a href={`https://wa.me/?text=${encodeURIComponent(shareText(link))}`} target="_blank" rel="noopener noreferrer" className={smallBtn} data-testid={`payment-link-whatsapp-${link.id}`}>
            <WhatsAppIcon className="w-3.5 h-3.5" /> WhatsApp
          </a>
          <a
            href={`mailto:${link.client_email || ''}?subject=${encodeURIComponent('Your payment link – Elina K. Photography')}&body=${encodeURIComponent(shareText(link))}`}
            className={smallBtn}
            data-testid={`payment-link-email-${link.id}`}
          >
            <Mail className="w-3.5 h-3.5" /> Email
          </a>
        </div>
      )}
    </div>
  );
};
